.a8{justify-content:center;}